import React, { useEffect, useRef, useState } from 'react';
import './Header.scss';
import SearchBar from '../SearchBar';
import { TopHeaderV5, Dropdown, Modal, ButtonV3, DropdownButton, SearchDropdown, DropdownButtonSearch, rlibfn } from 'react-ui-lib';
import history from '../../Routers/history';
import {
    blockUiFun,
    getSelectedBotData,
    highlightSearchedResult,
    updateFirstParam,
    builBotByData,
    updateBotValue,
    updateSelectedBot,
    toggleSideBar,
    removeSelectedBot,
    currentUserLogout,
    getGenericData,
    updateGenericLang,
    updateBotListData,
    updateCurrentTabStatus,
    getBotInfo,
    updateSelectedSource,
    getSourceList,
    getLogs
} from '../../Redux/Actions/uiActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddIcon from '../../../assets/icons/ic_config_create_green.png';
import SettingsIcon from '../../../assets/icons/ic_settings_purple.png';
import PUBLISHICON from '../../../assets/icons/ic_publish_blue.svg';
import DROPDOWNICON from '../../../assets/icons/ic_gray_dropdown.svg';
import LANGICON from '../../../assets/icons/ic_language.png';
import CLOSEICON from '../../../assets/icons/ic_close_grey_dark.png';
import OPENICON from '../../../assets/icons/ic_opne_white.png';
import COPYICON from '../../../assets/icons/ic_copy.png';
import LOGOUTICON from '../../../assets/icons/ic_logout_grey.svg';
import STARTICON from '../../../assets/icons/start_group.svg';
import LOGSICON from '../../../assets/icons/sideNavIcons/ic_logsBlack.png';
import BOTBLUEICON from '../../../assets/icons/ic_menu_bot_blue.svg';
import { hideSideNavArr } from '../../Utils';
import { KB } from '../../Utils/constants';
import PublishFilter from '../PublishFilter';
import { checkFeatureFlag } from '../../../constants';

function Header(props) {
    const {
        availableBotList,
        isCustomBot,
        highlightSearchedData,
        userName,
        editableBotData,
        blockUiFun,
        getSelectedBotData,
        highlightSearchedResult,
        selectedBot,
        selectedBotId,
        updateFirstParam,
        currentGenericLang,
        builBotByData,
        updateBotValue,
        updateSelectedBot,
        toggleSideBar,
        removeSelectedBot,
        currentUserLogout,
        getGenericData,
        updateGenericLang,
        updateBotListData,
        updateCurrentTabStatus,
        botInfo,
        getBotInfo,
        selectedBotData,
        selectedSource,
        updateSelectedSource,
        getSourceList,
        sourceList,
        getLogs,
    } = props;

    const vanityUrl = history.location.pathname === '/bot-list' ? undefined : selectedBotData?.SETTINGS?.SERVER_IP_PORT?.VALUE;

    const [botListVisibility, setBotListVisibility] = useState(false);
    const [createConfigVisibility, setCreateConfigVisibility] = useState(false);
    const [profileMenuVisibility, setProfileMenuVisibility] = useState(false);
    const [configModeVisibility, setConfigModeVisibility] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [buildState, setBuildState] = useState('live');
    let [buildMessage, setBuildMessage] = useState('');
    const [logoutConfirm, setLogoutConfirm] = useState(false);
    const [firstParam, setFirstParam] = useState(window.location.pathname.split('/')[1]);
    const [copyState, setCopyState] = useState(false);
    const botMenuRef = useRef(null);
    const addConfigRef = useRef(null);
    const profileMenuRef = useRef(null);
    const [ botName, setBotName ] = useState('');
    const [ openPublishModalType, setOpenPublishModalType ] = useState('publish');
    const [ openPublishModal, setOpenPublishModal ] = useState(false);
    let botSettingUrl = '', botSettingClass = 'menu-list-anchor';
    let checkSecondParam = window.location.pathname.split('/')[2];

    const isDeveloper = localStorage.getItem('dev_mode_secret') && localStorage.getItem('dev_mode_secret') === 'SECRETDEVTOOLOPTIONSFORBOTFORGE';
    const iframeSource = !!process.env.PRODUCT_BOT_BOTFORGE ? (process.env.PRODUCT_BOT_BOTFORGE + '?eb-chatbot-userId=' + (localStorage.getItem('user_id') || '') + '-botforge') : undefined;

    let localBuildState = localStorage.getItem('local_build') && localStorage.getItem('local_build') === 'true';
    if(isDeveloper) {
        localBuildState = true;
        localStorage.setItem('local_build', true);
    }

    if(firstParam && firstParam === 'genericconfig' && selectedBot !== 'Select Bot') {
        removeSelectedBot();
    }

    const language = [
        { name: 'Arabic', code: 'ar' },
        { name: 'Cantonese', code: 'zh-yue' },
        { name: 'Dutch', code: 'nl' },
        { name: 'English', code: 'en' },
        { name: 'French', code: 'fr' },
        { name: 'German', code: 'de' },
        { name: 'Italian', code: 'it' },
        { name: 'Malay', code: 'ms' },
        { name: 'Mandarin', code: 'zh-cmn' },
        { name: 'Polish', code: 'pl' },
        { name: 'Portuguese', code: 'pt' },
        { name: 'Spanish', code: 'es' },
        { name: 'Swedish', code: 'sv' }
    ]

    const getLanguage = () => {
        let tempLang = 'English';
        tempLang = language.filter(obj => obj.code === currentGenericLang);
        return (tempLang && tempLang.length ? tempLang[0].name : 'English');
    }

    // const handleOnBotSelect = (item) => {
    //     const currentBotId = item?.id;
    //     if (!currentBotId || currentBotId === null || currentBotId === 'null') {
    //         return;
    //     }
    //     blockUiFun(true);
    //     updateCurrentTabStatus('chatbot');
    //     setBotListVisibility(false);
    //     localStorage.setItem('bot_id', currentBotId);
    //     getSelectedBotData(currentBotId, () => {
    //         setTimeout(() => { blockUiFun(false); }, 3000)
    //     }, () => {
    //         blockUiFun(false);
    //     });
    //     if (isCustomBot) {
    //         if (Object.keys(highlightSearchedData).length !== 0) {
    //             highlightSearchedResult({});
    //         }
    //         updateFirstParam(currentBotId + '');
    //         history.push(`/${currentBotId}/chatbot`);
    //     } else {
    //         updateFirstParam(currentBotId + '');
    //         history.push(`/${currentBotId}`);
    //     }
    // }

    function showBotList() {
        let menuElm = document.getElementById('botListId');
        if (menuElm.classList.contains('hide-Tooltip')) {
            setBotListVisibility(true);
        } else {
            setBotListVisibility(false);
        }
    }

    const showCreateConfig = () => {
        history.push('/importconfig');
        // setCreateConfigVisibility(!createConfigVisibility);
    }

    useEffect(() => {
        checkSecondParam = window.location.pathname.split('/')[2];

        function handleClick(e) {
            if (e.target.classList.contains('botName') || e.target.id === 'botListBtnId') {
                showBotList();
                setProfileMenuVisibility(false);
                setCreateConfigVisibility(false);
            } else if (e.target.classList.contains('menu-list-anchor')) {
                if (availableBotList && availableBotList.length && selectedBot !== 'Select Bot' && isCustomBot && checkSecondParam && checkSecondParam !== 'settings') {
                    botSettingUrl = '/' + selectedBotId + '/settings';
                    botSettingClass = 'menu-list-anchor';
                    updateFirstParam(selectedBotId + '');
                    history.push(botSettingUrl);
                } else {
                    botSettingUrl = window.location.pathname;
                    botSettingClass = 'menu-list-anchor disabled'
                }
            } else if (botMenuRef.current && !botMenuRef.current.contains(e.target)) {
                setBotListVisibility(false);
                if (addConfigRef.current && !addConfigRef.current.contains(e.target)) {
                    // if (!document.getElementsByName('Add config')[0].contains(e.target)) {
                        setCreateConfigVisibility(false);
                    // }
                }
                if (profileMenuRef.current && !profileMenuRef.current.contains(e.target)) {
                    if (!document.getElementById('accountOptionsBtnId').contains(e.target)) {
                        setProfileMenuVisibility(false);
                    } else {
                        if (document.getElementById('accountOptionsId').classList.contains('hide-Tooltip')) {
                            setProfileMenuVisibility(true);
                        } else {
                            setProfileMenuVisibility(false);
                        }
                    }
                } else {
                }
            }
        }

        document.addEventListener('mousedown', handleClick, false);

        return () => {
            document.removeEventListener('mousedown', handleClick, false);
        }

    }, []);

    useEffect(() => {
        if(editableBotData.botId) {
            getSourceList(editableBotData.botId, (res) => {
                // if(res && res.length && !selectedSource?._id) {
                if(res && res.length) {
                    updateSelectedSource(res[0]);
                }
            }, (err) => {
                console.log("Source list error -> ", err)
            });
        }
    }, [editableBotData.botId])

    useEffect(() => {
        if(sourceList && sourceList.length && (localStorage.getItem('sourceName') !== selectedSource?.sourceName)) {
            const tempSource = sourceList.filter(obj => obj.sourceName === (localStorage.getItem('sourceName') || 'webpage'));
            updateSelectedSource(tempSource && tempSource.length ? tempSource[0] : sourceList[0]);
        }
    }, [sourceList])

    useEffect(() => {
    }, [buildState, buildMessage, isOpen, logoutConfirm, firstParam, currentGenericLang, copyState]);

    useEffect(() => {
        setBotName(botInfo?.name);
    }, [botInfo])

    const logoutCurrentUser = () => {
        try {
            updateBotListData([]);
            updateBotValue({});
            updateSelectedBot(false);
            toggleSideBar(false);
            localStorage.clear();
            removeSelectedBot();
            currentUserLogout();
            history.push('/login');
        } catch (err) {
            console.log('unhandled call', err);
        }
    }

    const getUserFromLS = (type) => {
        let userName = '';
        let userInitials = '';
        let userData;
        try {
            userData = JSON.parse(localStorage.getItem('user_data'));
            userName = userData.firstName + ' ' + userData.lastName;
            userInitials = userData.firstName.slice(0, 1).toUpperCase() + ' ' + userData.lastName.slice(0, 1).toUpperCase();
        } catch (err) {
            console.log('Error in fetching user data', err);
            localStorage.clear();
            updateFirstParam('login');
            history.push('/login');
        }
        if (type === 'icon') {
            return userInitials;
        }

        if(type === 'email') {
            return userData.email
        }
        return (userName);
    }

    if (firstParam !== window.location.pathname.split('/')[1]) {
        setFirstParam(window.location.pathname.split('/')[1]);
    }

    const lnaguageSelect = (code) => {
        updateGenericLang(code);
        blockUiFun(true);
        getGenericData(code, (res) => {
            blockUiFun(false);
        }, (err) => {
            console.log('err', err);
            blockUiFun(false);
        })
    }

    const onsubmitCallback = (selectedSourceData) => {
        toggleModal(false);
        blockUiFun(true, true);
        if (openPublishModalType === 'publish') {
            builBotByData('live', editableBotData.SETTINGS.SERVER_IP_PORT.VALUE, selectedSourceData, (res, status) => {
                if (res && res.error && res.error.code && res.error.message && res.error.message !== '') {
                    setBuildState('live-err');
                    setBuildMessage(res.error.message);
                    setTimeout(() => {
                        toggleModal(true, 'true');
                    }, 10)
                } else if (res && res.error) {
                    setBuildState('live-err');
                    setBuildMessage('Something went wrong =>' + JSON.stringify(res));
                    setTimeout(() => {
                        toggleModal(true, 'true');
                    }, 10)
                } else if (status === 504) {
                    setBuildState('live-err');
                } else {
                    setBuildState('live');
                    setTimeout(() => {
                        toggleModal(true, 'true');
                    }, 10)
                }
                blockUiFun(false);
            }, () => {
                blockUiFun(false);
                setBuildState('live-err');
                setTimeout(() => {
                    toggleModal(true, 'true');
                }, 10)
            });
        } else {
            builBotByData('local', editableBotData.UI_OPTIONS.DASHBOARD.LOCAL_SERVER_IP_PORT.VALUE, selectedSourceData, (res, status) => {
                if (res && res.error && res.error.code && res.error.message && res.error.message !== '') {
                    setBuildState('local-err');
                    setBuildMessage(res.error.message);
                    setTimeout(() => {
                        toggleModal();
                    }, 10)
                } else if (res && res.error) {
                    setBuildState('local-err');
                    setBuildMessage('Something went wrong =>' + JSON.stringify(res));
                    setTimeout(() => {
                        toggleModal();
                    }, 10)
                } else if (status === 504) {
                    setBuildState('local-err');
                } else {
                    setBuildState('local');
                    setTimeout(() => {
                        toggleModal();
                    }, 10)
                }
                blockUiFun(false);
            }, (error) => {
                setBuildState('local-err');
                setBuildMessage('Something went wrong =>' + error.msg);
                setTimeout(() => {
                    toggleModal();
                }, 10)
                blockUiFun(false);
            });
        }
        setOpenPublishModal(false);
    }

    const toggleModal = (currState = true, openStatus) => {
        if (!currState) {
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            setIsOpen(false);
        } else if (openStatus) {
            document.getElementsByTagName('body')[0].style.overflow = openStatus === 'true'
                ? 'auto'
                : 'hidden';
            setIsOpen(true);
        } else {
            document.getElementsByTagName('body')[0].style.overflow = isOpen
                ? 'auto'
                : 'hidden';
            setIsOpen(!isOpen);
        }
    };

    const closeWindow = () => {
        toggleModal();
        setLogoutConfirm(false);
    }

    // const showFlashMessage = (val) => {
    //     setCopyState(!val);
    //     setTimeout(() => {
    //         setCopyState(val);
    //     }, 2000);
    // }

    // const copyToClipboard = (str) => {
    //     const el = document.createElement('textarea');
    //     el.value = str;
    //     document.body.appendChild(el);
    //     el.select();
    //     document.execCommand('copy');
    //     document.body.removeChild(el);
    //     showFlashMessage(false);
    // };

    const buildBody = (type) => {
        let baseBotURL = 'http://127.0.0.1:5001';
        let currentBot = editableBotData.botId;
        if (type === 'Live') {
            baseBotURL = editableBotData.SETTINGS && editableBotData.SETTINGS.SERVER_IP_PORT.VALUE;
            currentBot = editableBotData && editableBotData.SETTINGS && editableBotData.SETTINGS.BOT_NAME && editableBotData.SETTINGS.BOT_NAME.VALUE && editableBotData.SETTINGS.BOT_NAME.VALUE.length ? editableBotData.SETTINGS.BOT_NAME.VALUE : editableBotData.botId;
        }
        return (
            <div className='build-modal-body'>
                <header className='build-modal-header'>
                    <h3 className='build-modal-header__text'>{type} bot build Completed! Changes applied to the bot</h3>
                    <button className='modal-close-button'>
                        <img className='modal-close-icon' height='24px' width='24px' alt='close' src={CLOSEICON} onClick={() => { toggleModal(false) }} />
                    </button>
                </header>
                <section className='build-modal-body-section'>
                    <div className={'flash-message-for-copy' + (copyState ? ' show' : '')}>Link Copied !!</div>
                    <div className='build-modal-box'>
                        <header className='build-modal-box-header'>
                            <h3 className='build-modal-box-header__text'>Default Testing Window Link:</h3>
                            <button className='build-modal-open-link'>
                                <a className='build-modal-box-body__link' target='_blank' href={`${baseBotURL}/${currentBot}`}>
                                    <img className='build-modal-open-icon' height='24px' width='24px' alt='open link' src={OPENICON} />
                                    Open bot in new tab
                                </a>
                            </button>
                        </header>
                        <div className='build-modal-box-body'>
                            <a className='build-modal-box-body__link' target='_blank' href={`${baseBotURL}/${currentBot}`}>{`${baseBotURL}/${currentBot}`}</a>
                            <button className='build-modal-copy-link' onClick={() => { rlibfn.copyText(iframeScript, rlibfn.showFlashMessage({message: `${baseBotURL}/${currentBot}`, type: 'success'})) }}>
                                <img className='build-modal-copy-icon' height='24px' width='24px' alt='copy link' src={COPYICON} />
                            </button>
                        </div>
                    </div>
                    <div className='build-modal-box'>
                        <header className='build-modal-box-header'>
                            <h3 className='build-modal-box-header__text'>IframeTesting Window Link:</h3>
                            <button className='build-modal-open-link'>
                                <a className='build-modal-box-body__link' target='_blank' href={`${baseBotURL}/${currentBot}/iframe`}>
                                    <img className='build-modal-open-icon' height='24px' width='24px' alt='open link' src={OPENICON} />
                                    Open bot in new tab
                                </a>
                            </button>
                        </header>
                        <div className='build-modal-box-body'>
                            <a className='build-modal-box-body__link' target='_blank' href={`${baseBotURL}/${currentBot}/iframe`}>{`${baseBotURL}/${currentBot}/iframe`}</a>
                            <button className='build-modal-copy-link' onClick={() => { rlibfn.copyText(iframeScript, rlibfn.showFlashMessage({message: `${baseBotURL}/${currentBot}/iframe`, type: 'success'})) }}>
                                <img className='build-modal-copy-icon' height='24px' width='24px' alt='copy link' src={COPYICON} />
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    const onClickOutside = (e, btnAction) => {
        if(!(document.getElementsByClassName('topHeaderBot')[0].contains(e.target)) || btnAction){
            setBotListVisibility(false);
        }
    }

    const onBotsettingClick = () => {
        if(!isCustomBot) return false;
        checkSecondParam = window.location.pathname.split('/')[2];
        if (availableBotList && availableBotList.length && selectedBot !== 'Select Bot' && isCustomBot && checkSecondParam && checkSecondParam !== 'settings') {
            botSettingUrl = '/' + selectedBotId + '/settings';
            botSettingClass = 'menu-list-anchor';
            updateFirstParam(selectedBotId + '');
            history.push(botSettingUrl);
        } else {
            botSettingUrl = window.location.pathname;
            botSettingClass = 'menu-list-anchor disabled'
        }
    } 

    const renderContent = () => {
        let logPath = `/${localStorage.getItem('bot_id')}/logs`;
        if (logoutConfirm) {
            return (<div style={{ fontSize: '1rem', textAlign: 'center' }}>Are you sure you want to logout?</div>);
        // } else if (buildState === 'local') {
        //     return buildBody('Local');
        // } else if (buildState === 'local-err') { // TODO: 504 timeout handler
        //     return (
        //         <div className='modal-body-content'>Local bot build Failed! <div className='content'>{buildMessage}</div></div>
        //     );
        // } else if (buildState === 'live') {
        //     return buildBody('Live');
        } else if (buildState === 'live-check') {
            return (
                <div className='modal-body-content'>{buildMessage}</div>
            );
        // } else if (buildState === 'live-err') { // TODO: 504 timeout handler
        //     return (
        //         <div className='modal-body-content'>Live bot build Failed! <div className='content'>{buildMessage}</div></div>
        //     );
        } else if (buildState === 'local' || buildState === 'live' || buildState === 'live-err' || buildState === 'local-err') {
            return (
                <div className='modal-body-content' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', textAlign: 'center', position: 'relative'}}>
                    <img className='modal-close-icon' height='24px' width='24px' title='Close' alt='close' src={CLOSEICON} onClick={() => { toggleModal(false) }} style={{position: 'absolute', right: '-1.4rem', top: '0', cursor: 'pointer'}} />
                    <img className='modal-body-content__title-img' src={STARTICON} alt='***' />
                    <h1 className='modal-body-content__title' style={{marginBottom: '0', color: '#27336b', fontWeight: 'bolder'}}>Nicely done!</h1>
                    <h2 className='modal-body-content__sub-title' style={{margin: '0.5rem 0', fontSize: '1.25rem'}}>We are integrating your UI</h2>
                    <p className='modal-body-content__text'>This may take a while, Please click on "Refresh" button in <img src={LOGSICON} alt='' height={14} style={{marginRight: '0.25rem', marginTop: '-0.18rem'}} />Logs page to update status of your build</p>
                    <ButtonV3 
                        key = 'Redirect to logs'
                        name = 'Redirect to logs'
                        title = 'Redirect to logs'
                        btnstyle = {{margin: '1rem 0', fontWeight: 'bold'}}
                        onClick={() => {history.push(logPath)}}
                    />
                </div>
            );
        } else {
            return <div>Done</div>
        }
    };

    const header = {
        title: logoutConfirm ? 'Confirm Logout' : buildState === 'live-check' ? 'Confirmation Message' : 'Flash Message',
        closeOnOutsideClick: logoutConfirm ? false : buildState !== 'live-err' && buildState !== 'local-err' ? true : false,
        style: logoutConfirm ? {} : buildState === 'live-check' ? {} : {
            display: 'none'
        }
    };
    const footer = {
        onSubmit: closeWindow,
        submitText: 'Okay',
        disableSubmit: false,
        customStyle: {
            justifyContent: 'flex-end'
        }
    };
    const confirmationFooter = {
        onSubmit: logoutConfirm ? logoutCurrentUser : onsubmitCallback,
        onCancel: closeWindow,
        submitText: 'Confirm',
        cancelText: 'Cancel',
        disableSubmit: false,
        disableCancel: false,
        customStyle: {
            justifyContent: 'flex-end'
        }
    };
    const customStyle = {
        maxWidth: '550px'
    };

    const modalClassName = logoutConfirm || (buildState === 'live-check') ? ' confirmation' : '';

    // return (
    //     <>
    //         <TopHeader4
    //             customStyle={{ width: "auto", backgroundColor: "#ffff" }}
    //             toggleOptions={() => { }}
    //             selectedBot={selectedBot}
    //             topHeaderClass=" botForge-header"
    //             // menuDownArrow={DownArrowIcon}
    //             botListMenu={
    //                 <div className='bot-list-menu' ref={botMenuRef}>
    //                     <SearchDropdown
    //                         dropdownId={"botListId"}
    //                         list={availableBotList}
    //                         isHidden={!botListVisibility}
    //                         showDropDownTitle={"Total bots - " + (availableBotList ? availableBotList.length : 0)}
    //                         showDropDownHeading={true}
    //                         showTooltip={true}
    //                         onClickHandler={handleOnBotSelect}
    //                         dropDownPosition={{
    //                             top: "1.5em",
    //                             left: "-8.5em",
    //                             zIndex: "1001",
    //                         }}
    //                         title="botList"
    //                         botSettingOnClick={onBotsettingClick}
    //                         botSettingUrl={botSettingUrl}
    //                         botSettingBtnStyle={isCustomBot ? {padding: "5px 10px", color: 'inherit', backgroundColor: '#F5F7FA'} : {padding: "5px 10px", color: 'inherit', backgroundColor: '#F5F7FA', opacity: '0.5', cursor: 'not-allowed'}}
    //                         redirectUrl={(path) => {history.push(path)}}
    //                         showDropDownFooter={true}
    //                         dropDownFooter='Create config'
    //                         footerOnClick={showCreateConfig}
    //                         createBot={{
    //                             title: 'Add config',
    //                             color: '#228242',
    //                             bgcolor: '#22824224',
    //                             name: 'Add config',
    //                             'data-topheader': 'addconfig',
    //                             className: 'add-config-button'
    //                         }}
    //                         activeId={localStorage?.getItem("bot_id") || ""}
    //                         onClickOutside={onClickOutside}
    //                     />
    //                     {/* <Dropdown
    //                         dropdownId={"botListId"}
    //                         list={availableBotList}
    //                         isHidden={!botListVisibility}
    //                         showDropDownTitle={"Total bots - " + (availableBotList ? availableBotList.length : 0)}
    //                         showDropDownHeading={true}
    //                         showDropDownFooter={false}
    //                         showTooltip={true}
    //                         onClick={showBotList}
    //                         dropDownPosition={{
    //                             top: "2em",
    //                             left: "-10em"
    //                         }}
    //                         onClickHandler={handleOnBotSelect}
    //                         title="botList"
    //                     /> */}
    //                     {/* <div className={'bot-config-options' + (createConfigVisibility ? ' active' : '')} ref={addConfigRef}>
    //                         <div className='create-config-options-body'>
    //                             <h4>You can import JSON or create a config from scratch</h4>
    //                         </div>
    //                         <div className='create-config-options-buttons'>
    //                             <Link to='/importconfig' style={{ 'text-decoration': 'none' }} onClick={() => {
    //                                 setCreateConfigVisibility(false);
    //                             }}>
    //                                 <Button
    //                                     className='red modal__content__footer--cancel-button'
    //                                     text='Import JSON'
    //                                 />
    //                             </Link>
    //                             <Link to='/createconfig' style={{ 'text-decoration': 'none' }} onClick={() => {
    //                                 setCreateConfigVisibility(false);
    //                             }}>
    //                                 <Button
    //                                     className='blue modal__content__footer--submit-button'
    //                                     text='Create Config'
    //                                 />
    //                             </Link>
    //                         </div>
    //                     </div> */}
    //                 </div>
    //             }
    //             showBotList={!botListVisibility}
    //             topHeaderSettingIcon={{
    //                 title: 'Click here for settings tab',
    //                 data: 'botsettingtab',
    //                 src: SettingsIcon,
    //                 alt: 'bot_settings',
    //                 className: botSettingClass,
    //                 id: 'botSettingsTab'
    //             }}
    //             createButtonIcon={AddIcon}
    //             createBot={{
    //                 title: 'Add config',
    //                 color: '#228242',
    //                 bgcolor: '#22824224',
    //                 name: 'Add config',
    //                 'data-topheader': 'addconfig',
    //                 className: 'add-config-button'
    //             }}
    //             onCreateBotClick={showCreateConfig}
    //             userName={userName !== 'Unknown User' ? userName : getUserFromLS()}
    //             userInitials={getUserFromLS('icon')}
    //             accountOptions={
    //                 <div className='profile menu' ref={profileMenuRef}>
    //                     <Dropdown
    //                          dropdownId={"accountOptionsId"}
    //                         //  list={[]}
    //                          isHidden={!profileMenuVisibility}
    //                          showDropDownHeading={false}
    //                          showDropDownFooter={true}
    //                          showTooltip={true}
    //                          onClick={() => {}}
    //                          dropDownPosition={{
    //                             top: "3.5em",
    //                             left: "-8em"
    //                          }}
    //                          footerBtn={
    //                             //  <span id="dropdown-item1" style={{minHeight: "2.5rem", display: "flex", alignItems: "center", padding: ".375rem 1rem", boxSizing: "border-box"}} onClick={() => { setLogoutConfirm(true); setTimeout(() => { toggleModal(); }, 10); }}>
    //                             //      <p className="m-0 cursor-pointer" style={{textAlign: "left", color: "#444A52"}}>
    //                             //          Logout
    //                             //          <img src={LOGOUTICON} alt="logout_icon" style={{marginLeft: "8px"}}/>
    //                             //      </p>
    //                             //  </span>
    //                             <ButtonV3 
    //                                 name = {'Logout'}
    //                                 btnStyleType = {'secondary'}
    //                                 btnstyle = {{border: '0', width: '100%', justifyContent: 'flex-start', minHeight: '2.5rem', height: 'auto', padding: ".375rem 1rem"}}
    //                                 rightIcon={<img src={LOGOUTICON} alt="logout_icon"/>}
    //                                 onClick={() => { setLogoutConfirm(true); setTimeout(() => { toggleModal(); }, 10); }}
    //                             />
    //                          }
    //                          title="accountOptions"
    //                         list={isDeveloper ?
    //                             [
    //                                 {
    //                                     title: "Generic Config", action: () => {
    //                                         updateFirstParam('genericconfig');
    //                                         updateCurrentTabStatus('uisettings');
    //                                         updateGenericLang('en');
    //                                         removeSelectedBot();
    //                                         blockUiFun(true);
    //                                         getGenericData('en', (res) => {
    //                                             blockUiFun(false);
    //                                             history.push(`/genericconfig/uisettings`);
    //                                         }, (err) => {
    //                                             console.log('err', err);
    //                                             blockUiFun(false);
    //                                         })
    //                                     }
    //                                 },
    //                             ]
    //                             :
    //                             []
    //                         }
    //                     />
    //                 </div>
    //             }
    //             showProfileMenu={!profileMenuVisibility}
    //             rightChildren={
    //                 <>
    //                     {(selectedBotId && selectedBot && checkSecondParam) || (firstParam === 'genericconfig') ? <SearchBar /> : null}
    //                     { true && <Dropdown
    //                         dropdownId={"configModeId"}
    //                         isHidden={!configModeVisibility}
    //                         showDropDownHeading={false}
    //                         showDropDownFooter={false}
    //                         showTooltip={true}
    //                         onClick={() => {}}
    //                         dropDownPosition={{
    //                         top: "3.5em",
    //                         left: "-8em"
    //                         }}
    //                         title="accountOptions"
    //                         list={[
    //                                 {
    //                                     title: "Default Config", action: () => {
    //                                         updateFirstParam('genericconfig');
    //                                         updateCurrentTabStatus('uisettings');
    //                                         updateGenericLang('en');
    //                                         removeSelectedBot();
    //                                         blockUiFun(true);
    //                                         getGenericData('en', (res) => {
    //                                             blockUiFun(false);
    //                                             history.push(`/${selectedBotId}/chatbot`);
    //                                         }, (err) => {
    //                                             console.log('err', err);
    //                                             blockUiFun(false);
    //                                         })
    //                                     }
    //                                 },
    //                                 {
    //                                     title: "Generic Config", action: () => {
    //                                         updateFirstParam('genericconfig');
    //                                         updateCurrentTabStatus('uisettings');
    //                                         updateGenericLang('en');
    //                                         removeSelectedBot();
    //                                         blockUiFun(true);
    //                                         getGenericData('en', (res) => {
    //                                             blockUiFun(false);
    //                                             history.push(`/genericconfig/uisettings`);
    //                                         }, (err) => {
    //                                             console.log('err', err);
    //                                             blockUiFun(false);
    //                                         })
    //                                     }
    //                                 },
    //                             ]
    //                         }
    //                     /> }
    //                     {!isDeveloper && !localBuildState && (selectedBotId && selectedBot && checkSecondParam && !(firstParam === 'genericconfig')) ?
    //                         <ButtonV3
    //                             key='Publish'
    //                             name="Publish"
    //                             color='#2A77DB'
    //                             // bgcolor='#fff'
    //                             // border='1px solid #2A77DB'
    //                             className='single-publish-button'
    //                             leftIcon={<img src={PUBLISHICON} alt="publishicon" style={{height: "1rem", width: "1rem"}}/>}
    //                             btnStyleType='secondary'
    //                             onClick={
    //                                 (e) => {
    //                                     setBuildState('live-check');
    //                                     setBuildMessage('Please confirm if you want to publish the changes.');
    //                                     setTimeout(() => {
    //                                         toggleModal(props);
    //                                     }, 10)
    //                                 }
    //                             }
    //                         />
    //                         :
    //                         (selectedBotId && selectedBot && checkSecondParam && !(firstParam === 'genericconfig')) ?
    //                             <DropdownButton
    //                                 key='Publish'
    //                                 name="Publish"
    //                                 color='#2A77DB'
    //                                 // bgcolor='#fff'
    //                                 // border='1px solid #2A77DB'
    //                                 div1Style = {{position: "relative"}}
    //                                 btnstyle={{color: '#2A77DB'}}
    //                                 btnStyleType='secondary'
    //                                 // div1Style={{
    //                                 //     'height': '32px',
    //                                 //     'marginLeft': '15px'
    //                                 // }}
    //                                 leftIcon={
    //                                     <img src={PUBLISHICON} alt="downChavron" style={{height: "1rem", width: "1rem"}} />
    //                                 }
    //                                 rightIcon={
    //                                     <img src={DROPDOWNICON} alt="downChavron"/>
    //                                 }
    //                                 rightIconInverted={
    //                                     <img src={DROPDOWNICON} alt="downChavron" style={{ transform: 'rotate(180deg)' }} />
    //                                 }
    //                                 list={[
    //                                     {
    //                                         title: "Live", action: (e) => {
    //                                             setBuildState('live-check');
    //                                             setBuildMessage('Please confirm if you want to publish the changes.');
    //                                             setTimeout(() => {
    //                                                 toggleModal(props);
    //                                             }, 10)
    //                                         }
    //                                     },
    //                                     {
    //                                         title: "Local", action: (e) => {
    //                                             blockUiFun(true, true);
    //                                             builBotByData('local', editableBotData.UI_OPTIONS.DASHBOARD.LOCAL_SERVER_IP_PORT.VALUE, (res) => {
    //                                                 if (res && res.error && res.error.code && res.error.message && res.error.message !== '') {
    //                                                     setBuildState('local-err');
    //                                                     setBuildMessage(res.error.message);
    //                                                     setTimeout(() => {
    //                                                         toggleModal();
    //                                                     }, 10)
    //                                                 } else if (res && res.error) {
    //                                                     setBuildState('local-err');
    //                                                     setBuildMessage('Something went wrong =>' + JSON.stringify(res));
    //                                                     setTimeout(() => {
    //                                                         toggleModal();
    //                                                     }, 10)
    //                                                 } else {
    //                                                     setBuildState('local');
    //                                                     setTimeout(() => {
    //                                                         toggleModal();
    //                                                     }, 10)
    //                                                 }
    //                                                 blockUiFun(false);
    //                                             }, (error) => {
    //                                                 setBuildState('local-err');
    //                                                 setBuildMessage('Something went wrong =>' + error.msg);
    //                                                 setTimeout(() => {
    //                                                     toggleModal();
    //                                                 }, 10)
    //                                                 blockUiFun(false);
    //                                             });
    //                                         }
    //                                     },
    //                                 ]}
    //                                 dropDownPosition={{
    //                                     position: "absolute",
    //                                     left: "3.7rem",
    //                                     top: "3em"
    //                                 }}
    //                                 showDropdown={isOpen}
    //                             />
    //                             : null
    //                     }
    //                     {(firstParam === 'genericconfig') ?
    //                         <DropdownButton
    //                             key={getLanguage()}
    //                             name={getLanguage()}
    //                             btnStyleType='secondary2'
                                
    //                             div1Style={{
    //                                 'height': '32px',
    //                             }}
    //                             leftIcon={
    //                                 <img src={LANGICON} alt="downChavron" width="16" />
    //                             }
    //                             rightIcon={
    //                                 <img src={DROPDOWNICON} alt="downChavron" />
    //                             }
    //                             rightIconInverted={
    //                                 <img src={DROPDOWNICON} alt="downChavron" style={{ transform: 'rotate(180deg)' }} />
    //                             }
    //                             list={
    //                                 language.map((elm, i) => {
    //                                     return ({
    //                                         title: elm.name,
    //                                         action: () => { lnaguageSelect(elm.code) }
    //                                     })
    //                                 })
    //                             }
    //                             dropDownPosition={{
    //                                 left: "2.5rem",
    //                                 top: "0.25rem"
    //                             }}
    //                             showDropdown={isOpen}
    //                         />
    //                         : null
    //                     }
    //                 </>
    //             }
    //             showGoLive={false}
    //         />
    //         <div className={'falsh-message-modal-container' + modalClassName}>
    //             <Modal
    //                 isOpen={isOpen}
    //                 onClose={() => { toggleModal(false); setLogoutConfirm(false); }}
    //                 header={header}
    //                 footer={logoutConfirm || (buildState === 'live-check') ? confirmationFooter : (buildState === 'live' || buildState === 'local') ? '' : footer}
    //                 hideFooter={!logoutConfirm && (buildState === 'live' || buildState === 'local')}
    //                 customStyle={customStyle}
    //             >
    //                 {renderContent()}
    //             </Modal>
    //         </div>
    //     </>
    // )
    return (
        <>
            <PublishFilter
                type={openPublishModalType}
                sourceList={sourceList}
                openPublishModal={openPublishModal}
                setOpenPublishModal={setOpenPublishModal}
                onPublishSave={onsubmitCallback}
            />
            <TopHeaderV5
                productName='BotForge'
                // showHeaderTitle={!(firstParam === 'genericconfig')}
                showBackBtn={true}
                environmentTag={process.env.CURRENT_ENV}
                backBtnClick={() => history.goBack()}
                isBotSelected={!(hideSideNavArr.includes(window.location.pathname) || firstParam === 'genericconfig')}
                botData={
                    window.location.pathname != '/bot-list' ? 
                    {
                        id: localStorage.getItem('bot_id'),
                        name: botName || localStorage.getItem('bot_name'),
                    } 
                    : 
                    {}
                }
                showBotDetailsBody={true}
                botDetailsBodyBtnTitle={'Show all bots'}
                botDetailsBodyBtnClick={() => {
                    history.push('/bot-list');
                }}
                showBotDetailsFooter={true}
                botDetailsFooterBtnTitle={'Create config'}
                botDetailsFooterBtnClick={showCreateConfig}
                hideMegaMenu={false}
                menuData={{
                    url: `${process.env.LBADMIN_URL}/api/v4/`,
                    authToken: localStorage.getItem('id_token'),
                    teamId: localStorage.getItem('team_id'),
                    ebPlatform: "botforge",
                    ignoreProductList: ["BotForge"],
                    errCb: (err) => {
                        // store.dispatch(sessionExpired());
                    },
                    teamConfig: {
                        title: 'TEAM CONFIGS',
                        children: [
                            {
                                route: '/bot-list',
                                title: 'Bot(s)',
                                icon: BOTBLUEICON,
                            }
                        ]
                    },
                    teamConfigClick: (route) => { history.push(route) }
                }}
                helpBtnClick={() => { }}
                iframeSource={iframeSource}
                showHelpButton={!(KB.IS_DOCBRAIN_OFF || KB.DOCBRAIN_WITHOUT_LLM) && iframeSource ? true : false}
                profileData={{
                    list: [
                        {
                            displayName: 'Logout',
                            name: 'logout',
                            imgSrc: LOGOUTICON,
                            action: (e)=>{
                                setLogoutConfirm(true);
                                setTimeout(() => toggleModal(), 10);
                            }
                        }
                    ],
                    userName: getUserFromLS(),
                    userInitials: getUserFromLS('icon'),
                    userEmail: getUserFromLS('email'),
                    teamName: localStorage.getItem('team_name') || localStorage.getItem('team_id') || '',
                    teamId : localStorage.getItem('team_id') || '',
                }}
                showTeam={localStorage.getItem('team_info') != 'undefined' ? true : false}
                showChangeTeam={false}
                changeTeamClick={() => { }}
                vanityUrl = {vanityUrl}
                rightChildren={
                    <>
                        {(selectedBotId && selectedBot && checkSecondParam) || (firstParam === 'genericconfig') ? <SearchBar /> : null}
                        {/* { true && <Dropdown
                            dropdownId={"configModeId"}
                            isHidden={!configModeVisibility}
                            showDropDownHeading={false}
                            showDropDownFooter={false}
                            showTooltip={true}
                            onClick={() => {}}
                            dropDownPosition={{
                            top: "3.5em",
                            left: "-8em"
                            }}
                            title="accountOptions"
                            list={[
                                    {
                                        title: "Default Config", action: () => {
                                            updateFirstParam('genericconfig');
                                            updateCurrentTabStatus('uisettings');
                                            updateGenericLang('en');
                                            removeSelectedBot();
                                            blockUiFun(true);
                                            getGenericData('en', (res) => {
                                                blockUiFun(false);
                                                history.push(`/${selectedBotId}/chatbot`);
                                            }, (err) => {
                                                console.log('err', err);
                                                blockUiFun(false);
                                            })
                                        }
                                    },
                                    {
                                        title: "Generic Config", action: () => {
                                            updateFirstParam('genericconfig');
                                            updateCurrentTabStatus('uisettings');
                                            updateGenericLang('en');
                                            removeSelectedBot();
                                            blockUiFun(true);
                                            getGenericData('en', (res) => {
                                                blockUiFun(false);
                                                history.push(`/genericconfig/uisettings`);
                                            }, (err) => {
                                                console.log('err', err);
                                                blockUiFun(false);
                                            })
                                        }
                                    },
                                ]
                            }
                        /> } */}
                        { selectedBotId && selectedBot && checkSecondParam && sourceList?.length > 0 && <DropdownButtonSearch
                            isSearchActive={false}
                            isLeftIcon={false}
                            text={"Source: " + sourceList.filter(elm => elm._id === selectedSource?._id)?.[0]?.sourceName || 'webpage'}
                            itemList={sourceList.map((item) => ({
                                displayJSX: <span style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}><span className={"body-container-sub-header__left-items wrap-ellipsis" + (selectedSource?._id === item._id ? ' selected': '')}>{item.sourceName}</span><span style={selectedSource?._id === item._id ? {color: '#fff'} : {color: '#8B929B'}}>{(item?.sourceLangISO || 'en').toUpperCase()}</span></span>,
                                title: item.sourceName,
                                name: item.sourceName,
                                value: item._id,
                                idx: item._id,
                                props: {
                                    style: selectedSource?._id === item._id ? {'background': '#2680EB', 'color': '#fff', 'fontWeight': '600'} : {},
                                    className: 'dropdown_list_element' + (selectedSource?._id === item._id ? ' selected': '')
                                },
                                onClick: (e, clickedItem) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    updateSelectedSource(sourceList.filter(elm => elm._id === clickedItem?.value)?.[0])
                                    localStorage.setItem('sourceName', clickedItem?.title || '');
                                    const currentLocation = location.pathname.split('/')[2]
                                    if(currentLocation === 'logs') {
                                        blockUiFun(true);
                                        getLogs({ "offset": "0", "limit": "20" }, () => {
                                            blockUiFun(false);
                                        });
                                    } else {
                                        getSelectedBotData(selectedBotId, () => {
                                            setTimeout(() => { blockUiFun(false); }, 3000)
                                        }, () => {
                                            blockUiFun(false);
                                        });
                                    }
                                }
                            }))}
                            customStyles={{ width: '100%', justifyContent: 'space-between' }}
                            btnstyle={{backgroundColor: '#fff', border: '1px solid #A6ADB6'}}
                            disabled={sourceList.length === 1}
                        />
                        }
                        {!isDeveloper && !localBuildState && (selectedBotId && selectedBot && checkSecondParam && !(firstParam === 'genericconfig')) ?
                            <ButtonV3
                                key='Publish'
                                name="Publish"
                                color='#2A77DB'
                                // bgcolor='#fff'
                                // border='1px solid #2A77DB'
                                className='single-publish-button'
                                leftIcon={<img src={PUBLISHICON} alt="publishicon" style={{height: "1rem", width: "1rem"}}/>}
                                btnStyleType='secondary'
                                onClick={
                                    (e) => {
                                        // if(checkFeatureFlag('FEATURE_MULTISOURCEBUILD')) {
                                            setOpenPublishModalType('publish')
                                            setOpenPublishModal(true);
                                        // } else {
                                        //     setBuildState('live-check');
                                        //     setBuildMessage('Please confirm if you want to publish the changes.');
                                        //     setTimeout(() => {
                                        //         toggleModal(props);
                                        //     }, 10)
                                        // }
                                    }
                                }
                            />
                            :
                            (selectedBotId && selectedBot && checkSecondParam && !(firstParam === 'genericconfig')) ?
                                <DropdownButton
                                    key='Publish'
                                    name="Publish"
                                    color='#2A77DB'
                                    // bgcolor='#fff'
                                    // border='1px solid #2A77DB'
                                    div1Style = {{position: "relative"}}
                                    btnstyle={{color: '#2A77DB'}}
                                    btnStyleType='secondary'
                                    // div1Style={{
                                    //     'height': '32px',
                                    //     'marginLeft': '15px'
                                    // }}
                                    leftIcon={
                                        <img src={PUBLISHICON} alt="downChavron" style={{height: "1rem", width: "1rem"}} />
                                    }
                                    rightIcon={
                                        <img src={DROPDOWNICON} alt="downChavron"/>
                                    }
                                    rightIconInverted={
                                        <img src={DROPDOWNICON} alt="downChavron" style={{ transform: 'rotate(180deg)' }} />
                                    }
                                    list={[
                                        {
                                            title: "Live", action: (e) => {
                                                // if(checkFeatureFlag('FEATURE_MULTISOURCEBUILD')) {
                                                    setOpenPublishModalType('publish');
                                                    setOpenPublishModal(true);
                                                // } else {
                                                //     setBuildState('live-check');
                                                //     setBuildMessage('Please confirm if you want to publish the changes.');
                                                //     setTimeout(() => {
                                                //         toggleModal(props);
                                                //     }, 10)
                                                // }
                                            }
                                        },
                                        {
                                            title: "Local", action: (e) => {
                                                // if(checkFeatureFlag('FEATURE_MULTISOURCEBUILD')) {
                                                    setOpenPublishModalType('local');
                                                    setOpenPublishModal(true);
                                                // } else {
                                                //     blockUiFun(true, true);
                                                //     builBotByData('local', editableBotData.UI_OPTIONS.DASHBOARD.LOCAL_SERVER_IP_PORT.VALUE, (res, status) => {
                                                //         if (res && res.error && res.error.code && res.error.message && res.error.message !== '') {
                                                //             setBuildState('local-err');
                                                //             setBuildMessage(res.error.message);
                                                //             setTimeout(() => {
                                                //                 toggleModal();
                                                //             }, 10)
                                                //         } else if (res && res.error) {
                                                //             setBuildState('local-err');
                                                //             setBuildMessage('Something went wrong =>' + JSON.stringify(res));
                                                //             setTimeout(() => {
                                                //                 toggleModal();
                                                //             }, 10)
                                                //         } else if(status === 504) {
                                                //             setBuildState('local-err');
                                                //         } else {
                                                //             setBuildState('local');
                                                //             setTimeout(() => {
                                                //                 toggleModal();
                                                //             }, 10)
                                                //         }
                                                //         blockUiFun(false);
                                                //     }, (error) => {
                                                //         setBuildState('local-err');
                                                //         setBuildMessage('Something went wrong =>' + error.msg);
                                                //         setTimeout(() => {
                                                //             toggleModal();
                                                //         }, 10)
                                                //         blockUiFun(false);
                                                //     });
                                                // }
                                            }
                                        },
                                    ]}
                                    dropDownPosition={{
                                        position: "absolute",
                                        left: "2.5rem",
                                        top: "3em",
                                        zIndex: 1
                                    }}
                                    showDropdown={isOpen}
                                />
                                : null
                        }
                        {(firstParam === 'genericconfig') ?
                            <DropdownButton
                                key={getLanguage()}
                                name={getLanguage()}
                                btnStyleType='secondary2'
                                
                                div1Style={{
                                    'height': '2.5rem',
                                }}
                                leftIcon={
                                    <img src={LANGICON} alt="downChavron" width="16" />
                                }
                                rightIcon={
                                    <img src={DROPDOWNICON} alt="downChavron" />
                                }
                                rightIconInverted={
                                    <img src={DROPDOWNICON} alt="downChavron" style={{ transform: 'rotate(180deg)' }} />
                                }
                                list={
                                    language.map((elm, i) => {
                                        return ({
                                            title: elm.name,
                                            action: () => { lnaguageSelect(elm.code) }
                                        })
                                    })
                                }
                                dropDownPosition={{
                                    left: "2.5rem",
                                    top: "0.25rem"
                                }}
                                showDropdown={isOpen}
                            />
                            : null
                        }
                        {
                            (isDeveloper && firstParam !== 'genericconfig') &&
                            <ButtonV3
                                key='generic-config'
                                name="Generic config"
                                className='single-publish-button'
                                btnStyleType='secondary'
                                onClick={
                                    (e) => {
                                        updateFirstParam('genericconfig');
                                        updateCurrentTabStatus('uisettings');
                                        updateGenericLang('en');
                                        removeSelectedBot();
                                        blockUiFun(true);
                                        getGenericData('en', (res) => {
                                            blockUiFun(false);
                                            history.push(`/genericconfig/uisettings`);
                                        }, (err) => {
                                            console.log('err', err);
                                            blockUiFun(false);
                                        })
                                    }
                                }
                            />
                        }
                    </>
                }
            />
            <div className={'falsh-message-modal-container' + modalClassName}>
                <Modal
                    isOpen={isOpen}
                    onClose={() => { toggleModal(false); setLogoutConfirm(false); }}
                    header={header}
                    footer={logoutConfirm || (buildState === 'live-check') ? confirmationFooter : (buildState === 'live' || buildState === 'local') ? '' : footer}
                    hideFooter={!logoutConfirm && (buildState === 'local' || buildState === 'live' || buildState === 'live-err' || buildState === 'local-err')}
                    customStyle={customStyle}
                >
                    {renderContent()}
                </Modal>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    return {
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : false,
        userName: state.UiReducer && state.UiReducer.user && state.UiReducer.user.userName ? state.UiReducer.user.userName : 'Unknown User',
        selectedBotId: state.UiReducer && state.UiReducer.selectedBotID ? state.UiReducer.selectedBotID : '',
        selectedBot: state.UiReducer && state.UiReducer.selectedBot ? state.UiReducer.selectedBot : 'Select Bot',
        isCustomBot: state.UiReducer && state.UiReducer.isCustomBot ? state.UiReducer.isCustomBot : false,
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : [],
        highlightSearchedData: state.UiReducer && state.UiReducer.highlightSearchedData ? state.UiReducer.highlightSearchedData : {},
        currentGenericLang: state.UiReducer && state.UiReducer.currentGenericLang ? state.UiReducer.currentGenericLang : 'en',
        botInfo: state?.UiReducer?.botInfo || {},
        selectedBotData: state?.UiReducer?.selectedBotData,
        selectedSource: state?.UiReducer?.selectedSource || {name: 'default', id: 'default'},
        sourceList: state?.UiReducer?.sourceList || [],
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        blockUiFun,
        getSelectedBotData,
        highlightSearchedResult,
        updateFirstParam,
        builBotByData,
        updateBotValue,
        updateSelectedBot,
        toggleSideBar,
        removeSelectedBot,
        currentUserLogout,
        getGenericData,
        updateGenericLang,
        updateBotListData,
        updateCurrentTabStatus,
        getBotInfo,
        updateSelectedSource,
        getSourceList,
        getLogs,
    },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);